import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  getDeglawyPortalContentById, getDeglawyPortalContents, updateDeglawyPortalContentById,
} from '../../axios/deglawyPortalRequests';
import {
  uploadFileURL,
} from '../../axios/requests';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  uploadFile,
} from '../../helperFunctions/uploadService';
import {
  DeglawyPortalContent, IDeglawyPortalContentStore,
} from '../storeInterfaces/deglawyPortalContentInterface';
import { RequestStatus } from 'mobx-store';

export class DeglawyPortalContentStore implements IDeglawyPortalContentStore {
  @observable deglawyPortalContentsList: DeglawyPortalContent[] = [];

  @observable selectedDeglawyPortalContent = new DeglawyPortalContent();

  @observable loading = false;

  @observable getDeglawyPortalContentRequestStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getDeglawyContents(languageCode: string = DefaultLanguage): Promise<void> {
    try {
      this.loading = true;
      this.getDeglawyPortalContentRequestStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(getDeglawyPortalContents, getHeader(languageCode)); console.log(response.data);
      this.deglawyPortalContentsList = this.restructureDeglawyContentsArray(response.data);
      console.log(this.deglawyPortalContentsList);
      this.getDeglawyPortalContentRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getDeglawyPortalContentRequestStatus = RequestStatus.FAILED;
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  private restructureDeglawyContentsArray(data: any): DeglawyPortalContent[] {
    const incomingData: DeglawyPortalContent[] = [];
    data.forEach((deglawyContent: any) => {
      const deglawyContentToPush: DeglawyPortalContent = new DeglawyPortalContent();
      deglawyContentToPush.setId(deglawyContent.deglawyPortalContentId);
      deglawyContentToPush.setTitle(deglawyContent.title);
      incomingData.push(deglawyContentToPush);
    });
    return incomingData;
  }

  private restructureDeglawyContent(data: any): DeglawyPortalContent {
    const structuredDeglawyContent: DeglawyPortalContent = new DeglawyPortalContent();
    structuredDeglawyContent.setId(data.deglawyPortalContentId);
    structuredDeglawyContent.setBody(data.body);
    structuredDeglawyContent.setTitle(data.title);
    if (data.headerImageUrl) {
      structuredDeglawyContent.setHeaderImage([{
        imageUrl: data.headerImageUrl, key: 1,
      }]);
    }
    return structuredDeglawyContent;
  }

  @action
  public async getDeglawyContentById(id: number, languageCode: string = DefaultLanguage): Promise<void> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getDeglawyPortalContentById(id), getHeader(languageCode));
      this.selectedDeglawyPortalContent = this.restructureDeglawyContent(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async updateDeglawyContentById(updatedDeglawyContent: DeglawyPortalContent, id: number, languageCode?: string | undefined): Promise<any> {
    try {
      delete updatedDeglawyContent.title;
      delete updatedDeglawyContent.deglawyPortalContentId;
      const headerImage = await this.uploadHeaderImage(updatedDeglawyContent.getHeaderImage());
      updatedDeglawyContent.setHeaderImage(headerImage);
      const response = await Connections.wadiDeglaAxios.httpPut(updateDeglawyPortalContentById(id), {
        ...updatedDeglawyContent.getContentToUpdate(),
        languageCode,
      });
    } catch (error) {
      console.log(error);
    }
  }

  private uploadHeaderImage(images: any[]) {
    const promises = [];
    const allImages: any[] = [];
    for (const image of images) {
      if (image.preview) {
        promises.push(
          uploadFile(uploadFileURL, image)
            .then((res: any) => {
              allImages.push({
                imageUrl: res.data.downloadURL,
              });
            }),
        );
      } else {
        allImages.push(image);
      }
    }
    return Promise.all(promises)
      .then(() => {
        console.log('done');
        return allImages;
      }).catch((error) => {
        console.log('error');
        return allImages;
      });
  }
}
